import { useAuth } from "context/AuthProvider";
import React, { useEffect, useState } from "react";

import { Card, CardBody, Col, Form, FormGroup, Input, Row, Button} from "reactstrap";
import { apiDepartamentosService } from "services/apiDepartamentosService";

const CalendarioFiltro = ({
  anno ,
  setAnno,
  departamentoId,
  setDepartamentoId,
  mes,
  setMes
}) => {
  const { empresa } = useAuth();
  const [departamentos, setDepartamentos] = useState([]);

  

  const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

  useEffect(() => {
    const fetchData = async () => {
      const dataDepartamentos = await apiDepartamentosService.getAll(
        empresa.id,
        0,
        1000
      );
      setDepartamentos(dataDepartamentos.content);
    };
    fetchData();
    return () => {};
  }, [empresa.id]);

  return (
    <>
      <Row>
        <Col>
          <Card className="shadow">
            <CardBody>
              <Form>
                <h6 className="heading-small text-muted mb-4">
                  Selección de Departamento  
                  <div className="mt-4">
                  <div className="d-flex flex-row align-items-center" style={{ flexWrap: 'nowrap' }}>


                  <div className="d-flex align-items-center mb-2 ml-2 mr-2">
                  <Button className="btn" size="sm" color={"success"} type="button" style={{ pointerEvents: 'none' }} >V</Button>
                    <span className="ms-2">Vacaciones</span>
                  </div>
                  <div className="d-flex align-items-center mb-2 ms-3 ml-2 mr-2">
                  <Button className="btn" size="sm" color={"info"} type="button" style={{ pointerEvents: 'none' }} >A</Button>
                    <span className="ms-2">Ausencias</span>
                  </div>
                  <div className="d-flex align-items-center mb-2 ms-3 ml-2 mr-2">
                  <Button className="btn" size="sm" color={"warning"} type="button" style={{ pointerEvents: 'none' }} >B</Button>
                    <span className="ms-2">Bajas</span>
                  </div>
                  <div className="d-flex align-items-center mb-2 ms-3 ml-2 mr-2">
                  <Button className="btn" size="sm" color={"danger"} style={{ pointerEvents: 'none' }} >F</Button>
                    <span className="ms-2">Festivos</span>
                  </div>
                  <div className="d-flex align-items-center mb-2 ms-3 ml-2 mr-2">
                  <Button className="btn" size="sm"  style={{ pointerEvents: 'none' }} >-</Button>
                    <span className="ms-2">No definido</span>
                  </div>
                  <div className="d-flex align-items-center mb-2 ms-3 ml-2 mr-2">
                  <Button className="btn" size="sm" color={"primary"}  style={{ pointerEvents: 'none' }} >- 
                    <span
                      className="position-absolute bg-white text-primary rounded-circle border"
                      style={{
                        top: "-5px",
                        right: "-5px",
                        width: "14px",
                        height: "14px",
                        fontSize: "9px",
                        lineHeight: "13px",
                        fontWeight: "bold",
                      }}
                    >
                  <i className="ni ni-watch-time" />
                </span>
                </Button>
                    <span className="ms-2">Permiso horario</span>
                    
                  </div>

</div>

</div>

                  </h6>
                 <h6 className="heading-small text-right mb-4">
                 
                </h6>

                <div className="pl-lg-4">
                  <Row>
                    <Col lg="4">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="centro">
                          Departamento
                        </label>

                        <Input
                          type="select"
                          name="departamento"
                          id="departamento"
                          value={departamentoId}
                          onChange={(e) => setDepartamentoId(e.target.value)}
                        >
                          <option key={"TODOS"} value={"TODOS"}>
                            Todos los departamentos
                          </option>

                          {departamentos.map((dep) => {
                            return (
                              <option key={dep.id} value={dep.id}>
                                {dep.nombre}
                              </option>
                            );
                          })}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col lg="4">
                      <FormGroup>
                        <label
                          className="form-control-label"
                          htmlFor="input-email"
                        >
                          Año
                        </label>
                        <Input className="form-control-alternative" type="number" id="year" name="year" min="1900" max="2100" step="1" value={anno} onChange={(e) => setAnno(e.target.value)} />
                                                    
                      </FormGroup>
                    </Col>
                    <Col lg="4">
                      <FormGroup>
                        <label
                          className="form-control-label"
                          htmlFor="input-email"
                        >
                          Mes
                        </label>
                        <Input
                          type="select"
                          name="mes"
                          id="mes"
                          value={mes}
                          onChange={(e) => setMes(e.target.value)}
                        >
                          <option key={"nullmes"} value={"null"}>
                            Seleccionar mes
                          </option>
                          {meses.map((m, index) => {
                            return (
                              <option key={index} value={index}>
                                {m}
                              </option>
                            );
                          })}
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </Form>
            </CardBody>
          </Card>
          
        </Col>
        
       
        
      </Row>
    </>
  );
};

export default CalendarioFiltro;
